module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/budget/budget-form/budget-form.component.css
// module id = ./src/app/finance/budget/budget-form/budget-form.component.css
// module chunks = main